import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "step-number" }
const _hoisted_2 = { class: "number flex-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-white flex-center"
}

import { STEP_STATUS } from '@/components/stepper/stepper.types';
import { computed } from 'vue';
import Spinner from '@/components/Spinner.vue';
import Icon from '@/components/icon/Icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepNumber',
  props: {
    number: null,
    status: null
  },
  setup(__props: any) {

const props = __props as {
  number: number | string;
  status: STEP_STATUS;
}



const isProgress = computed(() => props.status === STEP_STATUS.PROGRESS);
const isError = computed(() => props.status === STEP_STATUS.ERROR);
const isSuccess = computed(() => props.status === STEP_STATUS.SUCCESS);
const isNumber = computed(() => props.status === STEP_STATUS.ACTIVE || !props.status);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isNumber))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.number), 1))
        : _createCommentVNode("", true),
      (_unref(isProgress))
        ? (_openBlock(), _createBlock(Spinner, {
            key: 1,
            size: "20",
            class: "text-dark opacity-30"
          }))
        : _createCommentVNode("", true),
      (_unref(isError))
        ? (_openBlock(), _createBlock(Icon, {
            key: 2,
            name: "errorOutlined",
            size: "20",
            class: "text-white"
          }))
        : _createCommentVNode("", true),
      (_unref(isSuccess))
        ? (_openBlock(), _createBlock(Icon, {
            key: 3,
            name: "checkmark",
            size: "20",
            class: "text-dark"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})